"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Positions_1 = __importDefault(require("../common/enums/Positions"));
var PositionUtils = /** @class */ (function () {
    function PositionUtils(trigger, content, position, breathingRoom, centered, maxWidth) {
        if (breathingRoom === void 0) { breathingRoom = 12; }
        if (centered === void 0) { centered = false; }
        this.position = Positions_1.default.BOTTOM;
        this.triggerPosition = trigger.getBoundingClientRect();
        this.contentPosition = content.getBoundingClientRect();
        this.position = position;
        this.breathingRoom = breathingRoom;
        this.centered = centered;
        this.maxWidth = maxWidth;
    }
    PositionUtils.prototype.isOutsideVertical = function () {
        return this.position === Positions_1.default.TOP ?
            this.triggerPosition.top < this.contentPosition.height + this.breathingRoom :
            document.documentElement.clientHeight - this.triggerPosition.bottom < this.contentPosition.height + this.breathingRoom;
    };
    PositionUtils.prototype.isVerticalPosition = function () {
        return this.position === Positions_1.default.TOP || this.position === Positions_1.default.BOTTOM;
    };
    PositionUtils.prototype.isOutsideHorizontal = function () {
        return this.position === Positions_1.default.LEFT ?
            this.triggerPosition.left < this.contentPosition.width + this.breathingRoom :
            document.documentElement.clientWidth - this.triggerPosition.right < this.contentPosition.width + this.breathingRoom;
    };
    PositionUtils.prototype.isCenteredOutsideHorizontal = function () {
        return this.triggerPosition.left < this.contentPosition.width / 2 ||
            document.documentElement.clientWidth - this.triggerPosition.right < this.contentPosition.width / 2;
    };
    PositionUtils.prototype.isOutsideWindow = function () {
        if (!this.triggerPosition || !this.contentPosition) {
            return false;
        }
        switch (this.position) {
            case Positions_1.default.LEFT:
            case Positions_1.default.RIGHT:
                return this.isOutsideHorizontal();
            case Positions_1.default.TOP:
            case Positions_1.default.BOTTOM:
            default:
                return this.isOutsideVertical() ||
                    this.centered && this.isCenteredOutsideHorizontal();
        }
    };
    PositionUtils.prototype.getOffsetContentStyle = function () {
        if (this.isVerticalPosition && (this.contentPosition.left < 0 || this.contentPosition.right > document.documentElement.clientWidth)) {
            var left = this.triggerPosition.left;
            var right = document.documentElement.clientWidth - this.triggerPosition.right;
            if (left < right) {
                return {
                    left: 0,
                    right: 'initial',
                    transform: 'initial',
                    textAlign: 'left'
                };
            }
            else if (left > right) {
                return {
                    right: 0,
                    left: 'initial',
                    transform: 'initial',
                    textAlign: 'right'
                };
            }
        }
        return {};
    };
    PositionUtils.prototype.getWidthSubtrahend = function () {
        switch (this.position) {
            case Positions_1.default.RIGHT:
                return this.contentPosition.left + this.breathingRoom;
            case Positions_1.default.LEFT:
                return document.documentElement.clientWidth - this.contentPosition.right;
            default:
                return 2 * this.breathingRoom;
        }
    };
    PositionUtils.prototype.getNewWidth = function () {
        var newWidth = document.documentElement.clientWidth - this.getWidthSubtrahend();
        return Math.min(this.maxWidth, newWidth) + "px";
    };
    PositionUtils.prototype.getContentStyle = function () {
        if (!this.isOutsideWindow()) {
            return {};
        }
        var style = this.getOffsetContentStyle();
        if (this.isOutsideVertical()) {
            var newHeight = this.position === Positions_1.default.BOTTOM ?
                document.documentElement.clientHeight - this.contentPosition.top - this.breathingRoom :
                this.triggerPosition.top - (2 * this.breathingRoom);
            style.maxHeight = newHeight + "px";
        }
        if (this.maxWidth) {
            style.width = this.getNewWidth();
        }
        return style;
    };
    PositionUtils.prototype.createStyleStr = function (style) {
        return Object.keys(style).reduce(function (prev, key) {
            key = key.replace('textAlign', 'text-align');
            return key + ":" + style[key] + "; " + prev;
        }, '').trim();
    };
    PositionUtils.prototype.getContentStyleString = function () {
        var style = this.getContentStyle();
        return style && this.createStyleStr(style);
    };
    PositionUtils.prototype.getTriggerPosition = function () {
        return this.triggerPosition;
    };
    PositionUtils.prototype.getPosition = function () {
        return this.position;
    };
    return PositionUtils;
}());
exports.default = PositionUtils;
